import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { Icon } from '@nearpod-packages/base-library';
import StatefulIcon from '../../../Icons/Icons/StatefulIcon/StatefulIcon.js';
import styles from './NavigationItem.scss.js';
import keyboardKeyNames from '../../../../helpers/enums/keyboardKeyNames.js';
import { Theme } from '../../../../helpers/enums/themes/themeTypes.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';

const NavigationItem = /*#__PURE__*/forwardRef(_ref => {
  let {
    theme = Theme.WHITE,
    isCompact,
    icon,
    label,
    indentedLabel = false,
    pill,
    counter = '',
    aditionalTextForScreenReader = '',
    active,
    onClick,
    innerRef,
    onKeyPress = () => {},
    fontSize = sizeOptions.small,
    actionButton,
    onActionButtonClick = () => {}
  } = _ref;
  const isWhiteIcon = theme === Theme.DARK;
  const handleOnPressEnter = event => {
    if (event.key === keyboardKeyNames.ENTER) {
      onClick();
    } else {
      onKeyPress(event);
    }
  };
  const shouldShowActionButton = actionButton && theme === Theme.WHITE_EXTENDED;
  const handleActionButtonClick = event => {
    event.stopPropagation();
    onActionButtonClick();
  };
  return /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    onClick: onClick,
    role: "link",
    onKeyDown: event => handleOnPressEnter(event),
    className: classNames(styles.container, {
      [styles[`container--${theme}`]]: true,
      [styles['container--compact']]: isCompact,
      [styles.active]: active,
      [styles['container--with-pill']]: pill && counter === ''
    }),
    ref: innerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon-label-wrapper']
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: styles.icon,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(StatefulIcon, {
    code: icon,
    hover: !isWhiteIcon,
    disabled: isWhiteIcon
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.label, {
      [styles[`label--indented`]]: indentedLabel,
      [styles[`label--${fontSize}`]]: fontSize
    })
  }, label)), pill && /*#__PURE__*/React.createElement("span", {
    className: styles.pill,
    "aria-hidden": "true"
  }, pill), counter?.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, counter), shouldShowActionButton && /*#__PURE__*/React.createElement("button", {
    className: styles['action-button'],
    onClick: handleActionButtonClick,
    onKeyUp: handleActionButtonClick,
    "aria-label": actionButton.altText
  }, /*#__PURE__*/React.createElement(Icon, {
    name: actionButton.iconName,
    color: actionButton.color,
    isFilled: actionButton.isFilled,
    size: "xs"
  })), aditionalTextForScreenReader?.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: styles['sr-only']
  }, aditionalTextForScreenReader));
});
var NavigationItem$1 = NavigationItem;

export { NavigationItem$1 as default };
//# sourceMappingURL=NavigationItem.js.map
